import React, { Fragment, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { withRouter } from "react-router-dom";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Button,
  Box,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";
import Stack from "@mui/material/Stack";
import {
  actualizarLoadingApp_false,
  actualizarLoadingApp_true,
} from "../../../redux/AppDucks";
import {
  obtenerTodasConstanciasGuiaByIdDatosPredio,
  obtenerGuiaByIdDatosPredio,
} from "../../../redux/DucksUsuarioAgricola/ConstanciaDucks";
import { v4 as uuidv4 } from "uuid";
import { obtenerCatalogoMaguey } from "../../../redux/DucksUsuarioAgricola/CatalogoMagueyDucks";
import ModalMensaje from "../ModalMensaje";
import {
  obtenerDatosMagueyBy,
  agregarDatosMaguey,
  actualizarDatosMagueyReq,
  eliminarDatosMagueyReq,
  obtenerDatosMagueyByIdPredioEdicionDatos,
} from "../../../redux/DucksUsuarioAgricola/DatosMagueyDucks";
import Modal from "@mui/material/Modal";
import {
  //obtenerDatosPredioByIdCliente,
  obtenerTodosDatosPredio,
  setInitialData,
  actualizarDatosPredio,
  generarConstancia,
  obtenerDomicilioFiscal,
  obtenerTodosDatosPredioByNoPredio,
} from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import {
  agregarGuia,
  actualizarGuiaMaguey,
} from "../../../redux/DucksUsuarioAgricola/GuiaMagueyDucks";
import moment from "moment";
import estilos from "./PanelInformacionPredio.module.css";
import { agregarDatosMagueyHistorico } from "../../../redux/DucksUsuarioAgricola/DatosMagueyHistoricoDucks";
import Swal from "sweetalert2";
import { actualizarCliente } from "../../../redux/DucksBeneficiario/ClienteDucks";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const DatosPredio = () => {
  const dispatch = useDispatch();
  let dataPredios = [];
  let dataAsociados = [];
  const usuario = useSelector((store) => store.Usuario?.user[0]?.usuario);
  dataPredios = useSelector((store) => store.DatosPredioApi?.data?.data);
  dataAsociados = useSelector((store) => store.InformacionValidaApi.data.data);
  let dataMaguey = useSelector((store) => store.DatosMagueyApi.data.data);
  const dataEspecies = useSelector(
    (store) => store.CatalogoMagueyApi?.data?.data
  );

  const [modal, setModal] = React.useState(false);
  const [textoModal, setTextoModal] = React.useState("");
  const [tituloModal, setTituloModal] = React.useState("");

  const resetValores = (objectProducto) => {
    setModal(objectProducto.validacion);
  };

  const [isVisibleGuardar, setIsVisibleGuardar] = React.useState(false);
  const [noAsociado, setNoAsociado] = React.useState("");
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [check, setCheck] = React.useState(false);
  const [checkAgregarMaguey, setcheckAgregarMaguey] = React.useState(false);
  const [dataMagueySelect, setDataMagueySelect] = React.useState([]);
  const [sistemaPlantacion, setSistemaPlantacion] = React.useState(null);

  const [asociado, setAsociado] = React.useState({
    idcliente: null,
    numerosocio: null,
    personafisica: null,
    personamoral: null,
    nombrerazonsocial: null,
    fechasolicitud: null,
    rfc: null,
    telefono: null,
    correoelectronico: null,
    nombrerepresentantelegal: null,
    telefonorepresentante: null,
    correoelectronicorepresentante: null,
    empresacertificadora: null,
    idtipocliente: null,
    idlogin: null,
    idcartera: null,
    prediocliente: [],
  });
  const [temMaguey, setTemMaguey] = React.useState({
    numeroplantas: null,
    idgenerarguia: null,
    sistemaplantacion: null,
    distanciaplantas: null,
    distanciasurcos: null,
    edad: null,
    idcatalogomaguey: null,
    fechacreacion: null,
  });

  const [maguey, setMaguey] = React.useState({
    id: null,
    num_guia: null,
    edad: null,
    numeroplantas: null,
    especie: null,
  });

  const [temMagueyEdit, setTemMagueyEdit] = React.useState({
    especie: null,
    id: null,
    numeroplantas: null,
    edad: null,
  });
  const [especieMaguey, setEspecieMaguey] = React.useState(null);

  const [especieMagueyEdit, setEspecieMagueyEdit] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const [openModal, setOpenModal] = React.useState(false);

  const [numPredio, setNumPredio] = React.useState("");
  const handleClickOpen = (item) => {
    setEspecieMagueyEdit(item.catalogomaguey);
    setOpenModal(true);
    setTemMagueyEdit(item);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const [predio, setPredio] = React.useState({
    iddatospredio: null,
    superficiehectarea: null,
    longitudoeste: null,
    latitudnorte: null,
    edad: null,
    fecharegistro: null,
    estado: null,
    municipio: null,
    localidad: null,
    tenenciatierra: null,
    usufructotierra: null,
    representantecampo: null,
    ispropietario: null,
    nombrepropietario: null,
    idcliente: null,
    cliente: null,
  });
  const guardarRegistro = () => {
    let data = {
      // numeropredio: numMaxPredio +1,
      idcliente: asociado.idcliente,
      datospredio: [
        {
          ...predio,
        },
      ],
      datosmaguey: dataTable.map((d) => {
        delete d.iddatosmaguey;
        delete d.especie;
        return d;
      }),
      tipoGuia: isUnaGuia.op,
    };
  };

  const enviarInfo = async () => {
    try {
      const respuesta = await guardarRegistro().unwrap();
      setExito(true);
    } catch (rejectedValueOrSerializedError) {
      setErrorAgregar(true);
    }
    setAlert(true);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  React.useEffect(() => {
    if (!openModal) {
      if (
        predio !== null &&
        predio !== undefined &&
        predio.iddatospredio !== null
      ) {
        dispatch(
          obtenerDatosMagueyByIdPredioEdicionDatos(predio.iddatospredio)
        );
        setTemMagueyEdit({
          especie: null,
          id: null,
          numeroplantas: null,
          edad: null,
        });
      }
    }
  }, [openModal]);

  React.useEffect(() => {
    if (
      predio !== null &&
      predio !== undefined &&
      predio.iddatospredio !== null &&
      !check
    ) {
      dispatch(obtenerDatosMagueyByIdPredioEdicionDatos(predio.iddatospredio));
    }
  }, [predio]);

  React.useEffect(async () => {
    if (numPredio != "") {
      const handler = setTimeout(async () => {
        await dispatch(obtenerTodosDatosPredioByNoPredio(numPredio));
      }, 100);
      return () => clearTimeout(handler);
    }
  }, [numPredio]);

  useEffect(() => {
    setDataMagueySelect([]);
    setIsDisabled(true);
    setPredio({
      id: null,
      num_guia: null,
      num_predio: null,
      nombre_predio: null,
      num_cliente: null,
      nombre_cliente: null,
      cliente: null,
      iddatospredio: null,
      nombrepredio: null,
    });
    setMaguey({
      id: null,
      num_guia: null,
      num_predio: null,
      edad: null,
      numeroplantas: null,
      especie: null,
    });
    //dispatch(obtenerTodosDatosPredio());
    dispatch(obtenerCatalogoMaguey());
  }, []);

  const handleMagueyChange = (e) => {
    const { name, value } = e.target;
    setTemMaguey((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleMagueyEditChange = (e) => {
    const { name, value } = e.target;
    setTemMagueyEdit((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const style = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "#ddd",
    cursor: "not-allowed",
    pointerEvents: "none",
  };

  const styleNormal = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "white",
  };

  const agregarItemTabla = async () => {
    if (checkAgregarMaguey) {
      const fechaHoy = moment().format("YYYY-MM-DD");
      const aux = {
        sistemaplantacion: sistemaPlantacion?.op,
        distanciasurcos: Number(temMaguey?.distanciasurcos),
        distanciaplantas: Number(temMaguey?.distanciaplantas),
        numeroplantas: Number(temMaguey?.numeroplantas),
        numeroplantasregistro: Number(temMaguey?.numeroplantas),
        edad: Number(temMaguey?.edad),
        especie: especieMaguey?.nombrecomun,
        idcatalogomaguey: especieMaguey?.idcatalogomaguey,
        iddatospredio: Number(predio?.iddatospredio),
        fechacreacion: new Date(),
        isediciondatos: true,
        fechaactualizacion: new Date(fechaHoy).toISOString(),
      };
      if (aux.sistemaplantacion !== undefined) {
        if (
          aux.idcatalogomaguey !== undefined &&
          aux.iddatospredio !== undefined
        ) {
          if (
            aux.numeroplantas !== undefined &&
            aux.numeroplantas !== undefined &&
            aux.numeroplantas !== 0
          ) {
            if (aux.edad !== undefined && aux.edad !== undefined) {
              if (
                aux.distanciasurcos !== undefined &&
                aux.distanciasurcos !== undefined &&
                aux.distanciasurcos !== 0
              ) {
                if (
                  aux.distanciaplantas !== undefined &&
                  aux.distanciaplantas !== undefined &&
                  aux.distanciaplantas !== 0
                ) {
                  try {
                    await dispatch(actualizarLoadingApp_true());
                    await dispatch(agregarDatosMaguey({ data: aux }));
                    let datos = await dispatch(
                      obtenerDatosMagueyByIdPredioEdicionDatos(
                        predio.iddatospredio
                      )
                    );
                    const dataObtener = await dispatch(
                      obtenerTodosDatosPredio()
                    );

                    const filtro = dataObtener.payload.data.data.filter(
                      (anexo) => anexo.iddatospredio == predio.iddatospredio
                    );
                    const domicilioFiscal = await dispatch(
                      obtenerDomicilioFiscal(filtro?.[0].cliente.idcliente)
                    );
                    let numeroexterior = "";
                    let numerointerior = "";
                    let colonia = "";
                    if (domicilioFiscal.payload?.[0].numeroexterior === null)
                      numeroexterior = "s/n";
                    else
                      numeroexterior =
                        domicilioFiscal.payload?.[0].numeroexterior;
                    if (domicilioFiscal.payload?.[0].numerointerior === null)
                      numerointerior = "s/n";
                    else
                      numerointerior =
                        domicilioFiscal.payload?.[0].numerointerior;
                    if (domicilioFiscal.payload?.[0].colonia === null)
                      colonia = "sin colonia";
                    else colonia = domicilioFiscal.payload?.[0].colonia;
                    let domicilio =
                      domicilioFiscal.payload?.[0].calle +
                      ", " +
                      numerointerior +
                      ", " +
                      numeroexterior +
                      ", " +
                      colonia +
                      "," +
                      domicilioFiscal.payload?.[0].localidad +
                      ", " +
                      domicilioFiscal.payload?.[0].municipioalcaldia +
                      ", " +
                      domicilioFiscal.payload?.[0].estado +
                      ", " +
                      domicilioFiscal.payload?.[0].codigopostal;

                    let datosmaguey = [];
                    for (const i in filtro?.[0].datosmaguey) {
                      let { ...almacenar } = filtro?.[0].datosmaguey?.[i];
                      almacenar.especieCientifico =
                        almacenar.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico;
                      almacenar.especie = almacenar.catalogomaguey.nombrecomun;
                      datosmaguey.push(almacenar);
                    }
                    let data = {
                      numerosocio: filtro?.[0]?.cliente.numerosocio,
                      personafisica: filtro?.[0]?.cliente.personafisica,
                      personamoral: filtro?.[0]?.cliente.personamoral,
                      nombrerazonsocial: filtro?.[0]?.cliente.nombrerazonsocial,
                      telefono: filtro?.[0]?.cliente.telefono,
                      correoelectronico: filtro?.[0]?.cliente.correoelectronico,
                      fechasolicitud: new Date(),
                      iddatospredio: filtro?.[0]?.iddatospredio,
                      nombrepredio: filtro?.[0]?.nombrepredio,
                      municipio: filtro?.[0]?.municipio,
                      localidad: filtro?.[0]?.localidad,
                      estado: filtro?.[0]?.estado,
                      superficiehectarea: filtro?.[0]?.superficiehectarea,
                      latitudnorte: filtro?.[0]?.latitudnorte,
                      longitudoeste: filtro?.[0]?.longitudoeste,
                      datosmaguey: datosmaguey,
                      idcliente: filtro?.[0].cliente.idcliente,
                      domicilio: domicilio,
                      espropietario: filtro?.[0]?.espropietario,
                      nombrecompletopropietario:
                        filtro?.[0]?.nombrecompletopropietario,
                    };
                    await dispatch(generarConstancia(data));

                    const guiasConst = {
                      iddatospredio: predio.iddatospredio,
                      tipoconstancia: "NuevaGuia",
                    };
                    let guias = await dispatch(
                      obtenerTodasConstanciasGuiaByIdDatosPredio(guiasConst)
                    );
                    let estatus = await dispatch(
                      obtenerGuiaByIdDatosPredio({
                        iddatospredio: predio.iddatospredio,
                      })
                    );
                    for (const i in guias.payload) {
                      let { ...guiaEstatus } = guias.payload[i];
                      let filtroEstatus = estatus.payload.filter(
                        (anexo) =>
                          anexo.identificador == guiaEstatus.identificador
                      );
                      if (
                        filtroEstatus?.length > 0 &&
                        filtroEstatus?.[0]?.esactiva
                      ) {
                        let dataGuias = {
                          identificador: filtroEstatus?.[0]?.identificador,
                          iddatospredio: filtro?.[0]?.iddatospredio,
                          numerosocio: filtro?.[0]?.cliente.numerosocio,
                          nombrerazonsocial:
                            filtro?.[0]?.cliente.nombrerazonsocial,
                          nombrepredio: filtro?.[0]?.nombrepredio,
                          municipio: filtro?.[0]?.municipio,
                          localidad: filtro?.[0]?.localidad,
                          datosmaguey: datosmaguey,
                          idcliente: predio.idcliente,
                          datosmagueyproductor: datosmaguey,
                          page: Number(Number(i) + 1),
                          pages: guias.payload.length,
                        };
                        let generar = await dispatch(agregarGuia(dataGuias));
                      } else {
                        if (!filtroEstatus?.[0]?.esactiva) {
                          filtroEstatus[0].datosguia.page = Number(
                            Number(i) + 1
                          );
                          filtroEstatus[0].datosguia.pages =
                            guias.payload.length;
                          filtroEstatus[0].datosguia.datosmaguey =
                            filtroEstatus[0].datosguia.datosmagueyproductor;
                          filtroEstatus[0].datosguia.idcliente =
                            predio.idcliente;

                          let generar = await dispatch(
                            agregarGuia(filtroEstatus?.[0]?.datosguia)
                          );
                        }
                      }
                    }

                    setSistemaPlantacion(null);
                    setEspecieMaguey(null);

                    setTemMaguey({
                      numeroplantas: null,
                      idgenerarguia: null,
                      sistemaplantacion: null,
                      distanciaplantas: null,
                      distanciasurcos: null,
                      edad: null,
                      idcatalogomaguey: null,
                      fechacreacion: null,
                    });
                    setcheckAgregarMaguey(false);
                    setOpenModalVerificar(false);
                    await dispatch(actualizarLoadingApp_false());
                  } catch (error) {
                    alert("error", error);
                  }
                } else {
                  setTextoModal("Falta ingresar la distancia entre plantas");
                  setTituloModal("Campos Obligatorios");
                  setModal(true);
                  setOpenModalVerificar(false);
                }
              } else {
                setTextoModal("Falta ingresar la distancia de surcos");
                setTituloModal("Campos Obligatorios");
                setModal(true);
                setOpenModalVerificar(false);
              }
            } else {
              setTextoModal("Falta ingresar la edad");
              setTituloModal("Campos Obligatorios");
              setModal(true);
              setOpenModalVerificar(false);
            }
          } else {
            setTextoModal("Falta ingresar el número de plantas");
            setTituloModal("Campos Obligatorios");
            setModal(true);
            setOpenModalVerificar(false);
          }
        } else {
          setTextoModal("Falta ingresar la especie");
          setTituloModal("Campos Obligatorios");
          setModal(true);
          setOpenModalVerificar(false);
        }
      } else {
        setTextoModal("Falta ingresar un sistema de plantación");
        setTituloModal("Campos Obligatorios");
        setModal(true);
        setOpenModalVerificar(false);
      }
    } else {
      setTextoModal("No se puede actualizar");
      setTituloModal("Advertencia");
      setModal(true);
      setOpenModalVerificar(false);
    }
  };

  const handleAceptar = async () => {
    //await dispatch(actualizarLoadingApp_true())
    /*  const dataModificada = dataMagueySelect.map((item) => {
      if (item.id === temMagueyEdit.id) {
        return {
          id: temMagueyEdit.id,
          especie:
            especieMagueyEdit !== null
              ? especieMagueyEdit.nombrecomun
              : item.especie,
              numeroplantas: temMagueyEdit.numeroplantas,
          edad: temMagueyEdit.edad,
        };
      }
      return item;
    }); */
    if (temMagueyEdit) {
      const fechaHoy = moment().format("YYYY-MM-DD");
      let magueyData = {
        ...temMagueyEdit,
        idcatalogomaguey:
          especieMagueyEdit !== null && especieMagueyEdit !== undefined
            ? especieMagueyEdit.idcatalogomaguey
            : temMagueyEdit.idcatalogomaguey,
        isediciondatos: true,
        fechaactualizacion: new Date(fechaHoy).toISOString(),
      };
      delete magueyData.catalogomaguey;

      try {
        await dispatch(actualizarLoadingApp_true());
        let res = await dispatch(
          actualizarDatosMagueyReq({ data: magueyData })
        );

        const dataObtener = await dispatch(obtenerTodosDatosPredio());

        const filtro = dataObtener.payload.data.data.filter(
          (anexo) => anexo.iddatospredio == res.payload.data.data.iddatospredio
        );
        const domicilioFiscal = await dispatch(
          obtenerDomicilioFiscal(filtro?.[0].cliente.idcliente)
        );
        let numeroexterior = "";
        let numerointerior = "";
        let colonia = "";
        if (domicilioFiscal.payload?.[0].numeroexterior === null)
          numeroexterior = "s/n";
        else numeroexterior = domicilioFiscal.payload?.[0].numeroexterior;
        if (domicilioFiscal.payload?.[0].numerointerior === null)
          numerointerior = "s/n";
        else numerointerior = domicilioFiscal.payload?.[0].numerointerior;
        if (domicilioFiscal.payload?.[0].colonia === null)
          colonia = "sin colonia";
        else colonia = domicilioFiscal.payload?.[0].colonia;
        let domicilio =
          domicilioFiscal.payload?.[0].calle +
          ", " +
          numerointerior +
          ", " +
          numeroexterior +
          ", " +
          colonia +
          "," +
          domicilioFiscal.payload?.[0].localidad +
          ", " +
          domicilioFiscal.payload?.[0].municipioalcaldia +
          ", " +
          domicilioFiscal.payload?.[0].estado +
          ", " +
          domicilioFiscal.payload?.[0].codigopostal;

        let datosmaguey = [];
        for (const i in filtro?.[0].datosmaguey) {
          let { ...almacenar } = filtro?.[0].datosmaguey?.[i];
          almacenar.especieCientifico =
            almacenar.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico;
          almacenar.especie = almacenar.catalogomaguey.nombrecomun;
          datosmaguey.push(almacenar);
        }
        let data = {
          numerosocio: filtro?.[0]?.cliente.numerosocio,
          personafisica: filtro?.[0]?.cliente.personafisica,
          personamoral: filtro?.[0]?.cliente.personamoral,
          nombrerazonsocial: filtro?.[0]?.cliente.nombrerazonsocial,
          telefono: filtro?.[0]?.cliente.telefono,
          correoelectronico: filtro?.[0]?.cliente.correoelectronico,
          fechasolicitud: new Date(),
          iddatospredio: filtro?.[0]?.iddatospredio,
          nombrepredio: filtro?.[0]?.nombrepredio,
          municipio: filtro?.[0]?.municipio,
          localidad: filtro?.[0]?.localidad,
          estado: filtro?.[0]?.estado,
          superficiehectarea: filtro?.[0]?.superficiehectarea,
          latitudnorte: filtro?.[0]?.latitudnorte,
          longitudoeste: filtro?.[0]?.longitudoeste,
          datosmaguey: datosmaguey,
          idcliente: filtro?.[0].cliente.idcliente,
          domicilio: domicilio,
        };
        await dispatch(generarConstancia(data));

        const guiasConst = {
          iddatospredio: res.payload.data.data.iddatospredio,
          tipoconstancia: "NuevaGuia",
        };
        let guias = await dispatch(
          obtenerTodasConstanciasGuiaByIdDatosPredio(guiasConst)
        );
        let estatus = await dispatch(
          obtenerGuiaByIdDatosPredio({
            iddatospredio: res.payload.data.data.iddatospredio,
          })
        );
        for (const i in guias.payload) {
          let { ...guiaEstatus } = guias.payload[i];
          let filtroEstatus = estatus.payload.filter(
            (anexo) => anexo.identificador == guiaEstatus.identificador
          );
          if (filtroEstatus?.length > 0 && filtroEstatus?.[0]?.esactiva) {
            let dataGuias = {
              identificador: filtroEstatus?.[0]?.identificador,
              iddatospredio: filtro?.[0]?.iddatospredio,
              numerosocio: filtro?.[0]?.cliente.numerosocio,
              nombrerazonsocial: filtro?.[0]?.cliente.nombrerazonsocial,
              nombrepredio: filtro?.[0]?.nombrepredio,
              municipio: filtro?.[0]?.municipio,
              localidad: filtro?.[0]?.localidad,
              datosmaguey: datosmaguey,
              idcliente: predio.idcliente,
              datosmagueyproductor: datosmaguey,
              page: Number(Number(i) + 1),
              pages: guias.payload.length,
            };
            let generar = await dispatch(agregarGuia(dataGuias));
          } else {
            if (!filtroEstatus?.[0]?.esactiva) {
              filtroEstatus[0].datosguia.page = Number(Number(i) + 1);
              filtroEstatus[0].datosguia.pages = guias.payload.length;
              filtroEstatus[0].datosguia.datosmaguey =
                filtroEstatus[0].datosguia.datosmagueyproductor;
              filtroEstatus[0].datosguia.idcliente = predio.idcliente;

              let generar = await dispatch(
                agregarGuia(filtroEstatus?.[0]?.datosguia)
              );
            }
          }
        }
        for (const i in estatus.payload) {
          if (estatus?.payload?.[i]?.esactiva == true) {
            let dataGuiaActualizacion = {
              idguias: estatus.payload[i].idguias,
              esactiva: false,
              fechacreacion: estatus.payload[i].fechacreacion,
              isnoocupada: true,
            };
            await dispatch(
              actualizarGuiaMaguey({ data: dataGuiaActualizacion })
            );
          } else {
            let dataGuiaActualizacion = {
              idguias: estatus.payload[i].idguias,
              esactiva: false,
              fechacreacion: estatus.payload[i].fechacreacion,
            };
            await dispatch(
              actualizarGuiaMaguey({ data: dataGuiaActualizacion })
            );
          }
        }
        await dispatch(actualizarLoadingApp_false());
      } catch (rejectedValueOrSerializedError) {
        alert("Intentalo nuevamente.");
      }
      setOpenModal(false);
    }
    setOpenModal(false);
    //await dispatch(actualizarLoadingApp_false())
  };
  const eliminar = async (item) => {
    await dispatch(actualizarLoadingApp_true());
    const fechaHoy = moment().format("YYYY-MM-DD");

    //let result = await dispatch(eliminarDatosMagueyReq(item.iddatosmaguey));
    let dataActualizar = {
      iddatosmaguey: item.iddatosmaguey,
      numeroplantas: 0,
      edad: item.edad,
      isediciondatos: true,
      fechaactualizacion: new Date(fechaHoy).toISOString(),
    };
    let result = await dispatch(
      actualizarDatosMagueyReq({ data: dataActualizar })
    );
    const dataObtener = await dispatch(obtenerTodosDatosPredio());
    const filtro = dataObtener.payload.data.data.filter(
      (anexo) => anexo.iddatospredio == result.payload.data.data.iddatospredio
    );
    const domicilioFiscal = await dispatch(
      obtenerDomicilioFiscal(filtro?.[0].cliente.idcliente)
    );
    let numeroexterior = "";
    let numerointerior = "";
    let colonia = "";
    if (domicilioFiscal.payload?.[0].numeroexterior === null)
      numeroexterior = "s/n";
    else numeroexterior = domicilioFiscal.payload?.[0].numeroexterior;
    if (domicilioFiscal.payload?.[0].numerointerior === null)
      numerointerior = "s/n";
    else numerointerior = domicilioFiscal.payload?.[0].numerointerior;
    if (domicilioFiscal.payload?.[0].colonia === null) colonia = "sin colonia";
    else colonia = domicilioFiscal.payload?.[0].colonia;
    let domicilio =
      domicilioFiscal.payload?.[0].calle +
      ", " +
      numerointerior +
      ", " +
      numeroexterior +
      ", " +
      colonia +
      "," +
      domicilioFiscal.payload?.[0].localidad +
      ", " +
      domicilioFiscal.payload?.[0].municipioalcaldia +
      ", " +
      domicilioFiscal.payload?.[0].estado +
      ", " +
      domicilioFiscal.payload?.[0].codigopostal;

    let datosmaguey = [];
    for (const i in filtro?.[0].datosmaguey) {
      let { ...almacenar } = filtro?.[0].datosmaguey?.[i];
      almacenar.especieCientifico =
        almacenar.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico;
      almacenar.especie = almacenar.catalogomaguey.nombrecomun;
      datosmaguey.push(almacenar);
    }
    let data = {
      numerosocio: filtro?.[0]?.cliente.numerosocio,
      personafisica: filtro?.[0]?.cliente.personafisica,
      personamoral: filtro?.[0]?.cliente.personamoral,
      nombrerazonsocial: filtro?.[0]?.cliente.nombrerazonsocial,
      telefono: filtro?.[0]?.cliente.telefono,
      correoelectronico: filtro?.[0]?.cliente.correoelectronico,
      fechasolicitud: new Date(),
      iddatospredio: filtro?.[0]?.iddatospredio,
      nombrepredio: filtro?.[0]?.nombrepredio,
      municipio: filtro?.[0]?.municipio,
      localidad: filtro?.[0]?.localidad,
      estado: filtro?.[0]?.estado,
      superficiehectarea: filtro?.[0]?.superficiehectarea,
      latitudnorte: filtro?.[0]?.latitudnorte,
      longitudoeste: filtro?.[0]?.longitudoeste,
      datosmaguey: datosmaguey,
      idcliente: filtro?.[0].cliente.idcliente,
      domicilio: domicilio,
    };
    await dispatch(generarConstancia(data));
    const guiasConst = {
      iddatospredio: predio.iddatospredio,
      tipoconstancia: "NuevaGuia",
    };
    let guias = await dispatch(
      obtenerTodasConstanciasGuiaByIdDatosPredio(guiasConst)
    );
    let estatus = await dispatch(
      obtenerGuiaByIdDatosPredio({ iddatospredio: predio.iddatospredio })
    );
    for (const i in guias.payload) {
      let { ...guiaEstatus } = guias.payload[i];
      let filtroEstatus = estatus.payload.filter(
        (anexo) => anexo.identificador == guiaEstatus.identificador
      );
      if (filtroEstatus?.length > 0 && filtroEstatus?.[0]?.esactiva) {
        let dataGuias = {
          identificador: filtroEstatus?.[0]?.identificador,
          iddatospredio: filtro?.[0]?.iddatospredio,
          numerosocio: filtro?.[0]?.cliente.numerosocio,
          nombrerazonsocial: filtro?.[0]?.cliente.nombrerazonsocial,
          nombrepredio: filtro?.[0]?.nombrepredio,
          municipio: filtro?.[0]?.municipio,
          localidad: filtro?.[0]?.localidad,
          datosmaguey: datosmaguey,
          idcliente: predio.idcliente,
          datosmagueyproductor: datosmaguey,
          page: Number(Number(i) + 1),
          pages: guias.payload.length,
        };
        let generar = await dispatch(agregarGuia(dataGuias));
      } else {
        if (!filtroEstatus?.[0]?.esactiva) {
          filtroEstatus[0].datosguia.page = Number(Number(i) + 1);
          filtroEstatus[0].datosguia.pages = guias.payload.length;
          filtroEstatus[0].datosguia.datosmaguey =
            filtroEstatus[0].datosguia.datosmagueyproductor;

          let generar = await dispatch(
            agregarGuia(filtroEstatus?.[0]?.datosguia)
          );
        }
      }
    }
    setOpenModalVerificar(false);
    await dispatch(
      obtenerDatosMagueyByIdPredioEdicionDatos(filtro?.[0]?.iddatospredio)
    );
    await dispatch(actualizarLoadingApp_false());
  };
  const handlePredioChange = (e) => {
    let { name, value } = e.target;
    if (e.target.name == "nombrepredio") {
      value = value.toUpperCase();
    }
    setPredio((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleActualizarPredio = async () => {
    if (predio !== null && predio !== undefined) {
      if (
        predio.superficiehectarea !== "" &&
        predio.latitudnorte !== "" &&
        predio.longitudoeste !== "" &&
        predio.nombrepredio != ""
      ) {
        let dataPredio = {
          ...predio,
          superficiehectarea: predio.superficiehectarea,
          latitudnorte: predio.latitudnorte,
          longitudoeste: predio.longitudoeste,
          usuariocambio: usuario ? usuario : "",
          kmlFile: kmlFile,
        };
        let iddatospredio = dataPredio.iddatospredio;
        delete dataPredio.guias;
        delete dataPredio.cliente;
        delete dataPredio.datosmaguey;
        delete dataPredio.constancia;
        try {
          await dispatch(actualizarLoadingApp_true());
          await dispatch(actualizarDatosPredio({ data: dataPredio }));
          const dataObtener = await dispatch(obtenerTodosDatosPredio());

          const filtro = dataObtener.payload.data.data.filter(
            (anexo) => anexo.iddatospredio == iddatospredio
          );
          const domicilioFiscal = await dispatch(
            obtenerDomicilioFiscal(filtro?.[0].cliente.idcliente)
          );
          let numeroexterior = "";
          let numerointerior = "";
          let colonia = "";
          if (domicilioFiscal.payload?.[0].numeroexterior === null)
            numeroexterior = "s/n";
          else numeroexterior = domicilioFiscal.payload?.[0].numeroexterior;
          if (domicilioFiscal.payload?.[0].numerointerior === null)
            numerointerior = "s/n";
          else numerointerior = domicilioFiscal.payload?.[0].numerointerior;
          if (domicilioFiscal.payload?.[0].colonia === null)
            colonia = "sin colonia";
          else colonia = domicilioFiscal.payload?.[0].colonia;
          let domicilio =
            domicilioFiscal.payload?.[0].calle +
            ", " +
            numerointerior +
            ", " +
            numeroexterior +
            ", " +
            colonia +
            "," +
            domicilioFiscal.payload?.[0].localidad +
            ", " +
            domicilioFiscal.payload?.[0].municipioalcaldia +
            ", " +
            domicilioFiscal.payload?.[0].estado +
            ", " +
            domicilioFiscal.payload?.[0].codigopostal;

          let datosmaguey = [];
          for (const i in filtro?.[0].datosmaguey) {
            let { ...almacenar } = filtro?.[0].datosmaguey?.[i];
            almacenar.especieCientifico =
              almacenar.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico;
            datosmaguey.push(almacenar);
          }
          const parajeMayusculas = filtro?.[0]?.nombrepredio.toUpperCase();
          /*let paraje = ""
          for (const i in cortar) {
            if (i == 0 || cortar[i - 1] == " ") {
              paraje += cortar[i].toUpperCase() + ""
            } else {
              paraje += cortar[i].toLowerCase() + ""
            }
          }*/
          let data = {
            numerosocio: filtro?.[0]?.cliente.numerosocio,
            personafisica: filtro?.[0]?.cliente.personafisica,
            personamoral: filtro?.[0]?.cliente.personamoral,
            nombrerazonsocial: filtro?.[0]?.cliente.nombrerazonsocial,
            telefono: filtro?.[0]?.cliente.telefono,
            correoelectronico: filtro?.[0]?.cliente.correoelectronico,
            fechasolicitud: new Date(),
            iddatospredio: filtro?.[0]?.iddatospredio,
            nombrepredio: parajeMayusculas,
            municipio: filtro?.[0]?.municipio,
            localidad: filtro?.[0]?.localidad,
            estado: filtro?.[0]?.estado,
            superficiehectarea: filtro?.[0]?.superficiehectarea,
            latitudnorte: filtro?.[0]?.latitudnorte,
            longitudoeste: filtro?.[0]?.longitudoeste,
            datosmaguey: datosmaguey,
            idcliente: filtro?.[0].cliente.idcliente,
            domicilio: domicilio,
            espropietario: filtro?.[0]?.espropietario,
            nombrecompletopropietario: filtro?.[0]?.nombrecompletopropietario,
          };
          await dispatch(generarConstancia(data));
          await dispatch(actualizarLoadingApp_false());
          setCheck(false);
          setTextoModal("Datos actualizados correctamente");
          setTituloModal("");
          setModal(true);
        } catch (error) {
          alert("Intentalo de nuevo");
        }
      } else {
        setTextoModal("Los campos no pueden estar vacios");
        setTituloModal("Campos Obligatorios");
        setModal(true);
      }
    } else {
    }
  };

  /*   useEffect(() => {
    if (asociado !== null && asociado.idcliente !== null) {
      dispatch(obtenerDatosPredioByIdCliente(asociado.idcliente));
      setIsVisibleGuardar(true);
    } else {
      setIsVisibleGuardar(false);
    }
    dispatch(setInitialData());
  }, [asociado]); */

  /*   useEffect(() => {
    dispatch(obtenerUltimoRegistro());
    dispatch(obtenerTodosLosClientesConDetalle());
  }, []); */

  /*  useEffect(() => {
    dispatch(obtenerTodosLosClientesConDetalle());
  }, [dispatch]); */

  const [isKmlFile, setIsKmlFile] = React.useState(null);
  const [kmlFile, setKmlFile] = React.useState(null);
  const kmlHandler = (event) => {
    setKmlFile(event.target.files[0]);
    setIsKmlFile(true);
  };

  const body = (
    <>
      <div className="bg-light p-5 rounded ">
        <h3 className="text-center">Actualizar Maguey</h3>
        <div className="row">
          <div className="col-12">
            <label className="form-label">Especie: </label>

            <Autocomplete
              fullWidth
              disablePortal
              options={dataEspecies}
              getOptionLabel={(opcion) =>
                `${opcion.catalogomagueynombrecientifico.nombrecientifico}-${opcion.nombrecomun}` ||
                ""
              }
              value={especieMagueyEdit}
              onChange={(event, value) => {
                setEspecieMagueyEdit(value);
              }}
              sx={styleNormal}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField {...params} sx={styleNormal} size="small" />
              )}
            />
          </div>

          <div className="col-6">
            <label className="form-label">No. de Plantas:</label>
            <TextField
              fullWidth
              sx={styleNormal}
              type="number"
              inputProps={{
                inputMode: "numeric",
                min: 0,
              }}
              size="small"
              name="numeroplantas"
              onChange={handleMagueyEditChange}
              value={
                temMagueyEdit.numeroplantas !== null
                  ? temMagueyEdit.numeroplantas
                  : 0
              }
            />
          </div>
          <div className="col-6">
            <label className="form-label">Edad:</label>
            <TextField
              fullWidth
              sx={styleNormal}
              type="number"
              inputProps={{
                inputMode: "numeric",
                min: 0,
              }}
              size="small"
              name="edad"
              onChange={handleMagueyEditChange}
              value={temMagueyEdit.edad !== null ? temMagueyEdit.edad : 0}
            />
          </div>
        </div>
      </div>
    </>
  );
  const btnLimpiar = async (e) => {
    await window.location.reload(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [openModalVerificar, setOpenModalVerificar] = React.useState(false);
  const [titleModal, setTitleModal] = React.useState("");
  const [bodyModal, setBodyModal] = React.useState("");
  const [accion, setAccion] = React.useState("");
  const [dataModal, setDataModal] = React.useState("");

  const handleOpenModal = (data) => {
    setTitleModal(data.title);
    setBodyModal(data.body);
    setAccion(data.accion);
    setOpenModalVerificar(true);
    setDataModal(data.data);
  };
  const handleCloseModal = () => {
    setTitleModal("");
    setBodyModal("");
    setAccion("");
    setOpenModalVerificar(false);
    setDataModal("");
  };
  const modalComponent = () => {
    return (
      <div>
        <Modal
          open={openModalVerificar}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModal}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <center className="text-danger">{titleModal}</center>
            </Typography>
            <Typography
              id="modal-modal-description"
              component="h2"
              sx={{ mt: 2 }}
            >
              <p>{bodyModal}</p> <br />{" "}
              <center>
                <strong>¿Desea continuar?</strong>
              </center>
            </Typography>
            <br />
            <div className="row">
              <div className="col-5">
                <button
                  className="btn btn-success"
                  onClick={() => {
                    switch (accion) {
                      case "eliminarDeTabla":
                        eliminar(itemEliminar);
                        break;
                      case "guardarDatosPredio":
                        agregarItemTabla();
                        break;
                      case "limpiar":
                        btnLimpiar();
                        break;
                      default:
                        break;
                    }
                  }}
                >
                  CONTINUAR
                </button>
              </div>{" "}
              <div className="col-2"></div>
              <div className="col-5">
                <button
                  className="btn btn-dark"
                  onClick={() => handleCloseModal()}
                >
                  CANCELAR
                </button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    );
  };
  const [itemEliminar, setItemEliminar] = React.useState("");
  const botonEliminar = async (params) => {
    handleOpenModal({
      title: `¡Advertencia!`,
      body: `Está a seguro que desea eliminar los datos de este maguey?.`,
      accion: "eliminarDeTabla",
    });
    setItemEliminar(params);
  };
  const botonGuardar = async (params) => {
    handleOpenModal({
      title: `¡Advertencia!`,
      body: `¿Está a seguro que desea guardar los datos registrados del maguey?.`,
      accion: "guardarDatosPredio",
    });
  };
  const botonLimpiar = async (params) => {
    handleOpenModal({
      title: `¡Advertencia!`,
      body: `¿Está a seguro que desea limpiar los datos?.`,
      accion: "limpiar",
    });
  };
  const actualizarClienteSwal = async () => {
    Swal.fire({
      title: 'Ingrese un nombre',
      input: 'text',
      inputValue: predio?.cliente?.nombrerazonsocial || '',
      inputPlaceholder: 'Nombre',
      showCancelButton: true,
      confirmButtonText: 'Actualizar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (!value) {
          return 'Por favor ingrese un nombre';
        }
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        //const nombreIngresado = result.value;
        let data = { nombrerazonsocial: result.value, idcliente: predio?.idcliente }
        let ressultado = await dispatch(actualizarCliente(data))
        if(ressultado?.payload?.idcliente)Swal.fire('Success','Actualizado correctamente', 'success')
        else Swal.fire('Error','Ha ocurrido un error al actualizar el cliente', 'error')
        setPredio(prev => ({
          ...prev,
          cliente: {
            ...prev.cliente,
            nombrerazonsocial: result?.value
          }
        }));
      } else {
        console.log('Operación cancelada');
      }
    });
  }
  return (
    <Fragment>
      <br />
      <br />
      <form>
        <div className="container">
          <h2 className="text-center">Edición de Datos</h2>
          <div className="p-5 rounded ms-5">
            <div className="row">
              <div className="col-12">
                <h3 className={`${estilos.labelEspecial} text-center pt-3`}>
                  Datos Generales
                </h3>
                <div className="pt-2">
                  <div className="row g-3">
                    <div className="col-sm-4">
                      <label className="form-label">
                        <b>No. Predio "A":</b>
                      </label>

                      <Autocomplete
                        open={open}
                        onOpen={() => {
                          if (numPredio) {
                            setOpen(true);
                          }
                        }}
                        onClose={() => setOpen(false)}
                        inputValue={numPredio ? numPredio : ""}
                        onInputChange={(e, value) => {
                          setNumPredio(value);

                          if (!value) {
                            setOpen(false);
                          }
                        }}
                        fullWidth
                        disablePortal
                        options={dataPredios !== null ? dataPredios : []}
                        getOptionLabel={(opcion) =>
                          opcion ? opcion.iddatospredio + "" : ""
                        }
                        onChange={(event, value) => {
                          setPredio(value);
                        }}
                        sx={styleNormal}
                        isOptionEqualToValue={(option, value) =>
                          option.iddatospredio === value.iddatospredio
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                              background: "white",
                            }}
                            size="small"
                          />
                        )}
                      />
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={check}
                              onChange={(e) => {
                                setCheck(!check);
                              }}
                              name="Editar"
                            />
                          }
                          label="Editar"
                        />
                      </FormGroup>

                      <br />
                    </div>

                    <div className="col-sm-3">
                      <label className="form-label">
                        <b>No. Cliente:</b>
                      </label>
                      <TextField
                        fullWidth
                        disabled
                        sx={style}
                        size="small"
                        name="idcliente"
                        value={
                          predio !== null &&
                            predio !== undefined &&
                            predio?.cliente !== null
                            ? predio.cliente?.numerosocio
                            : ""
                        }
                      />

                      <br />
                    </div>

                    <div className="col-sm-4">
                      <label className="form-label">
                        <b>Nombre Cliente:</b>
                      </label>
                      <TextField
                        disabled
                        fullWidth
                        sx={style}
                        size="small"
                        value={
                          predio !== null &&
                            predio !== undefined &&
                            predio.cliente !== null
                            ? predio?.cliente?.nombrerazonsocial
                            : ""
                        }
                      />
                    </div>
                    {predio?.cliente?.nombrerazonsocial &&
                      <div className="col-sm-1 mt-3">
                        <Button className="btn-success" onClick={() => actualizarClienteSwal()}
                          style={{ background: "Green", color: "white" }} >
                          Actualizar Cliente
                        </Button>
                      </div>
                    }


                    <div className="col-sm-6">
                      <label className="form-label">
                        <b>Nombre del Predio:</b>
                      </label>
                      <TextField
                        fullWidth
                        sx={check ? styleNormal : style}
                        size="small"
                        name="nombrepredio"
                        value={
                          predio !== null &&
                            predio !== undefined &&
                            predio.nombrepredio !== null
                            ? predio?.nombrepredio
                            : ""
                        }
                        onChange={handlePredioChange}
                      />
                    </div>

                    <div className="col-sm-6">
                      <label className="form-label">
                        <b>Superficie (Hectáreas):</b>
                      </label>
                      <TextField
                        fullWidth
                        name="superficiehectarea"
                        sx={check ? styleNormal : style}
                        size="small"
                        value={
                          predio !== null && predio?.superficiehectarea !== null
                            ? predio?.superficiehectarea
                            : ""
                        }
                        onChange={handlePredioChange}
                      />
                    </div>

                    <div className="col-sm-6">
                      <label className="form-label">
                        <b>Latitud Norte:</b>
                      </label>
                      <TextField
                        fullWidth
                        sx={check ? styleNormal : style}
                        size="small"
                        name="latitudnorte"
                        value={
                          predio !== null && predio?.latitudnorte
                            ? predio?.latitudnorte
                            : ""
                        }
                        onChange={handlePredioChange}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label">
                        <b>Longitud:</b>
                      </label>
                      <TextField
                        fullWidth
                        name="longitudoeste"
                        sx={check ? styleNormal : style}
                        size="small"
                        value={
                          predio !== null && predio?.longitudoeste
                            ? predio?.longitudoeste
                            : ""
                        }
                        onChange={handlePredioChange}
                      />
                    </div>
                    {predio?.tipoguia == "NORMAL" && (
                      <div className="col-sm-6">
                        <label className="form-label">Subir Polígono:</label>

                        <Stack direction="row">
                          <label
                            htmlFor="contained-button-file"
                            style={{ width: 100 }}
                          >
                            {isKmlFile ? (
                              <>
                                <div>
                                  <p>Filename:{kmlFile.name}</p>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            <input
                              accept=".kml,.KML"
                              id="contained-button-file"
                              type="file"
                              disabled={
                                predio !== null &&
                                  predio?.iddatospredio !== null &&
                                  check
                                  ? false
                                  : true
                              }
                              style={{ display: "none" }}
                              onChange={kmlHandler}
                            />
                            <Button
                              variant="contained"
                              fullWidth
                              component="span"
                              disabled={
                                predio !== null &&
                                  predio?.iddatospredio !== null &&
                                  check
                                  ? false
                                  : true
                              }
                            >
                              Cargar
                            </Button>
                          </label>
                        </Stack>
                      </div>
                    )}

                    <div className="row mt-3">
                      <div className="col-4"></div>
                      <div className="col-4 texte-center ">
                        <Button
                          fullWidth
                          variant="contained"
                          disabled={
                            predio !== null &&
                              predio !== undefined &&
                              predio?.iddatospredio !== null &&
                              check
                              ? false
                              : true
                          }
                          onClick={() => handleActualizarPredio()}
                        >
                          Actualizar{" "}
                        </Button>
                      </div>
                    </div>

                    <hr />
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkAgregarMaguey}
                            onChange={(e) => {
                              setcheckAgregarMaguey(!checkAgregarMaguey);
                            }}
                            name="Agregar Maguey"
                          />
                        }
                        label="Agregar Maguey"
                      />
                    </FormGroup>

                    <div className="col-sm-12">
                      <label className="form-label">Especie: </label>

                      <Autocomplete
                        fullWidth
                        disablePortal
                        inputValue={
                          especieMaguey
                            ? `${especieMaguey.catalogomagueynombrecientifico.nombrecientifico} - ${especieMaguey.nombrecomun}`
                            : ""
                        }
                        options={dataEspecies ? dataEspecies : []}
                        getOptionLabel={(maguey) =>
                          `${maguey.catalogomagueynombrecientifico.nombrecientifico} - ${maguey.nombrecomun}`
                        }
                        onChange={(event, value) => {
                          setEspecieMaguey(value);
                        }}
                        sx={styleNormal}
                        isOptionEqualToValue={(option, value) =>
                          option.idcatalogomaguey === value.idcatalogomaguey
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={checkAgregarMaguey ? styleNormal : style}
                            size="small"
                          />
                        )}
                      />
                    </div>

                    <div className="col-sm-6">
                      <label className="form-label">No. de Plantas:</label>
                      <TextField
                        fullWidth
                        sx={checkAgregarMaguey ? styleNormal : style}
                        type="number"
                        inputProps={{
                          inputMode: "numeric",
                          min: 0,
                        }}
                        size="small"
                        defaultValue={0}
                        name="numeroplantas"
                        onChange={handleMagueyChange}
                        value={
                          temMaguey !== null && temMaguey.numeroplantas !== null
                            ? temMaguey.numeroplantas
                            : ""
                        }
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label">Edad:</label>
                      <TextField
                        fullWidth
                        sx={checkAgregarMaguey ? styleNormal : style}
                        type="number"
                        inputProps={{
                          inputMode: "numeric",
                          min: 0,
                        }}
                        size="small"
                        defaultValue={0}
                        name="edad"
                        onChange={handleMagueyChange}
                        value={
                          temMaguey !== null && temMaguey.edad !== null
                            ? temMaguey.edad
                            : ""
                        }
                      />
                    </div>

                    <div className="col-sm-6">
                      <label className="form-label">Distancia (Surcos):</label>
                      <TextField
                        fullWidth
                        sx={checkAgregarMaguey ? styleNormal : style}
                        type="number"
                        inputProps={{
                          inputMode: "numeric",
                          min: 0,
                        }}
                        size="small"
                        defaultValue={0}
                        name="distanciasurcos"
                        onChange={handleMagueyChange}
                        value={
                          temMaguey !== null &&
                            temMaguey.distanciasurcos !== null
                            ? temMaguey.distanciasurcos
                            : ""
                        }
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label">Distancia (Plantas):</label>
                      <TextField
                        fullWidth
                        sx={checkAgregarMaguey ? styleNormal : style}
                        type="number"
                        inputProps={{
                          inputMode: "numeric",
                          min: 0,
                        }}
                        size="small"
                        defaultValue={0}
                        name="distanciaplantas"
                        onChange={handleMagueyChange}
                        value={
                          temMaguey !== null &&
                            temMaguey.distanciaplantas !== null
                            ? temMaguey.distanciaplantas
                            : ""
                        }
                      />
                    </div>

                    <div className="col-sm-6">
                      <label className="form-label">
                        Sistema de Plantación
                      </label>
                      <Autocomplete
                        fullWidth
                        inputValue={
                          sistemaPlantacion ? sistemaPlantacion.op : ""
                        }
                        //disabled={asociado !== null ? false : true}
                        disablePortal
                        options={[
                          { id: 1, op: "CULTIVADO" },
                          { id: 2, op: "SEMICULTIVADO" },
                          { id: 3, op: "SILVESTRE" },
                        ]}
                        getOptionLabel={(opcion) => opcion.op}
                        onChange={(event, value) => {
                          setSistemaPlantacion(value);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={checkAgregarMaguey ? styleNormal : style}
                            size="small"
                          />
                        )}
                      />
                    </div>
                    <div className="row">
                      <div className="col-4"></div>
                      <div className="col-4 texte-center mt-3 ">
                        <Button
                          fullWidth
                          variant="contained"
                          disabled={
                            predio !== null &&
                              predio !== undefined &&
                              predio.iddatospredio !== null &&
                              checkAgregarMaguey
                              ? false
                              : true
                          }
                          onClick={() => botonGuardar()}
                        >
                          {" "}
                          Agregar Maguey{" "}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 pt-4">
                <Paper sx={{ width: "100%" }}>
                  <TableContainer sx={{ maxHeight: 600 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Especie</TableCell>
                          <TableCell>Nombre Común</TableCell>
                          <TableCell>Edad</TableCell>
                          <TableCell>Existencia</TableCell>
                          <TableCell>Opciones</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {predio !== null &&
                          predio !== undefined &&
                          predio.iddatospredio !== null &&
                          dataMaguey.map((item, i) => (
                            <TableRow
                              key={item.iddatosmaguey}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell>
                                {
                                  item?.catalogomaguey
                                    ?.catalogomagueynombrecientifico
                                    ?.nombrecientifico
                                }
                              </TableCell>
                              <TableCell>
                                {item?.catalogomaguey?.nombrecomun}
                              </TableCell>
                              <TableCell>{item.edad}</TableCell>
                              <TableCell>{item.numeroplantas}</TableCell>
                              <TableCell>
                                <button
                                  type="button"
                                  className="badge btn-warning text-dark btn-block me-3"
                                  onClick={() => handleClickOpen(item)}
                                >
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faPencil}
                                  /> <br /> Actualizar{" "}
                                </button>

                                <button
                                  type="button"
                                  className="badge btn-danger text-dark btn-block"
                                  onClick={() => botonEliminar(item)}
                                >
                                  <FontAwesomeIcon icon={faTrash} /> <br />{" "}
                                  Eliminar
                                </button>
                                <Dialog open={openModal} scroll="paper">
                                  <DialogContent dividers={true}>
                                    <DialogContentText
                                      ref={descriptionElementRef}
                                      tabIndex={-1}
                                    ></DialogContentText>
                                    {body}
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={handleClose}>
                                      Cancelar
                                    </Button>
                                    <Button onClick={handleAceptar}>
                                      Guardar{" "}
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div className="row" style={{ alignContent: "center" }}>
        <div align="center">
          <Button
            className="btn-success"
            onClick={() => botonLimpiar()}
            style={{ background: "Green", color: "white" }}
          >
            Finalizar
          </Button>
        </div>
      </div>
      {modal && (
        <ModalMensaje
          texto={textoModal}
          titulo={tituloModal}
          api={{ resetValores }}
        ></ModalMensaje>
      )}
      {modalComponent()}
    </Fragment>
  );
};

export default withRouter(DatosPredio);
